// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2_FnX","title":"Info_title__m92qS","selects":"Info_selects__1UDlI","requiredAsterisk":"Info_requiredAsterisk__36XU4"};